module.exports = __webpack_public_path__ + "img/南沙科金控股.c8389e80.png";